const $ = jQuery.noConflict();

function MegaMenuGhost() {

	let currentPosition = window.pageYOffset;
	const mainHeader = document.querySelector('.main-header');

	if ( 0 < currentPosition ) {
		mainHeader.classList.remove('main-header-ghost');
	} else {
		mainHeader.classList.add('main-header-ghost');
	}
}
export default MegaMenuGhost;